import { useNavigate } from 'hooks';
import { generatePushApiReportsEditPath } from 'modules/push-api/utils/generatePushApiReportsPath';
import { PUSH_API_STATUS } from 'modules/push-api/utils/subscriptionConsts';
import { useAccount } from 'modules/taboola-common-frontend-modules/account-configurations';
import ActionsCellRenderer from '../ActionsCellRenderer';

export const PushApiReportActionsCellRenderer = ({ data, ...rest }) => {
    const navigate = useNavigate();
    const { accountName } = useAccount();
    const buttonConfigs = [
        {
            onClick: () => {
                navigate(generatePushApiReportsEditPath(accountName, data.id));
            },
            isDisabled:
                data.endpoints.length > 1 ||
                data.status === PUSH_API_STATUS.TERMINATED ||
                !data.accountId ||
                data.accountId === '',
            iconLabel: 'edit-o',
            dataMetricComponent: 'EditActionButton',
        },
        {
            onClick: () => {},
            iconLabel: 'delete',
            isDisabled: true,
            dataMetricComponent: 'DeleteActionButton',
        },
    ];

    return <ActionsCellRenderer data={data} buttonConfigs={buttonConfigs} {...rest} />;
};
